import {
	all,
	takeEvery,
	put
} from "redux-saga/effects";
import {
	saveNamespace,
	saveTemplate,
	saveBrandStyle,
	getBrandStyle,
	saveWhatsappNumberAdmin,
	getWhatsappNumberAdmin,
	saveWhatsappMessengerSettings,
	saveChannelWhatsappNumbers,
	isBrandStyleUpdating,
	saveWhatsappNumberMetrics,
	saveWhatsappNumberConversationAnalyitcs,
} from "../actions/channel";
import {
	GET_NAME_SPACE,
	UPDATE_NAME_SPACE,
	GET_TEMPLATES,
	CREATE_TEMPLATE,
	GET_BRAND_STYLE,
	PUT_BRAND_STYLE,
	GET_WHATSAPP_ADMIN_NUMBERS,
	POST_WHATSAPP_ADMIN_NUMBERS,
	SYNC_TEMPLATES,
	GET_CHANNEL_WHATSAPP_NUMBERS,
	SEND_WHATSAPP_MESSENGER_SETTINGS,
	GET_WHATSAPP_MESSENGER_SETTINGS,
	GET_WHATSAPP_NUMBER_METRICS,
	DELETE_TEMPLATE,
	GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
	SAVE_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS,
} from "../constants/channel";

import ApiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";
import confirm from "./ConfirmSaga";

function* getNameSpace() {
	yield takeEvery(GET_NAME_SPACE, function* () {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp-namespaces");
			yield put(saveNamespace(res.data));
		} catch (err) {
			//   yield put(authStatus(false));
		}
	});
}

function* getWhatsappNumberMetricsSaga() {
	yield takeEvery(GET_WHATSAPP_NUMBER_METRICS, function* (action) {
		try {
			const res = yield ApiService.get(`/hulk/api/v1/whatsapp-info/${action.payload}`);

			if (res.status == "success") {
				yield put(saveWhatsappNumberMetrics(res.data));
			}
		} catch (err) {
		}
	});
}

function* updateNameSpace() {
	yield takeEvery(UPDATE_NAME_SPACE, function* (action) {
		try {
			const res = yield ApiService.put(
				`/hulk/api/v1/whatsapp-namespaces-public`,
				{},
				action.payload
			);
			yield put({ type: GET_NAME_SPACE });
		} catch (err) {
			yield put(console.log(err));
		}
	});
}

function* getTemplates() {
	yield takeEvery(GET_TEMPLATES, function* () {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp-templates/no");
			yield put(saveTemplate(res.data));
		} catch (err) {
			//   yield put(authStatus(false));
		}
	});
}

function* createTemplate() {
	yield takeEvery(CREATE_TEMPLATE, function* (action) {
		try {
			const res = yield ApiService.post(
				`/hulk/api/v1/whatsapp-templates`,
				{},
				action.payload
			);
			toastNotification({ res });
			yield put({ type: GET_TEMPLATES });
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
			yield put(console.log(err));
		}
	});
}
function* deleteTemplate() {
	yield takeEvery(DELETE_TEMPLATE, function* (action) {
		try {
			const res = yield ApiService.delete(
				`/hulk/api/v1/whatsapp-templates/${action.payload.name}`
			);
			toastNotification({ res });
			yield put({ type: GET_TEMPLATES });
		} catch (err) {
			toastNotification({ errorMessage: "Internal Server Error" });
			yield put(console.log(err));
		}
	});
}

function* getBrandStyles() {
	yield takeEvery(GET_BRAND_STYLE, function* () {
		try {
			const res = yield ApiService.get("/hulk/api/v1/brand-styles");
			if (res && res.status == "success") {
				yield put(saveBrandStyle(res.data[0]));
			}
		} catch (err) { }
	});
}

function* updateBrandStyles() {
	yield takeEvery(PUT_BRAND_STYLE, function* (action) {
		try {
			yield put(isBrandStyleUpdating(true))
			const res = yield ApiService.put(
				`/hulk/api/v1/brand-styles/${action.payload.id}`,
				{},
				action.payload.data
			);

			toastNotification({ res });
			if (res && res.status == "success") {
				yield put(getBrandStyle());
				yield put(isBrandStyleUpdating(false))
			} else {
				yield put(isBrandStyleUpdating(false))
			}
		} catch (err) {
			yield put(isBrandStyleUpdating(false))

		}
	});
}

function* getWhatsappNumberAdminSaga() {
	yield takeEvery(GET_WHATSAPP_ADMIN_NUMBERS, function* () {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp-numbers-admin");
			if (res && res.status == "success") {
				yield put(saveWhatsappNumberAdmin(res.data));
			}
		} catch (err) { }
	});
}

function* postWhatsappNumberAdmin() {
	yield takeEvery(POST_WHATSAPP_ADMIN_NUMBERS, function* (action) {
		console.log("action", action.payload);
		try {
			// if (confirmed) {
			//   action.payload.confirm = true;
			// }
			const res = yield ApiService.post(
				`/hulk/api/v1/whatsapp-numbers-admin`,
				{},
				action.payload
			);
			if (res.data.warn) {
				let res1 = yield confirm(res.data.warn);
				if (res1 == "Ok") {
					action.payload.confirm = true;
					yield put({
						type: POST_WHATSAPP_ADMIN_NUMBERS,
						payload: action.payload,
					});
				}
			} else {
				toastNotification({ res });
				if (res && res.status == "success") {
					yield put(getWhatsappNumberAdmin());
				}
			}
		} catch (err) { }
	});
}

function* syncTemplates() {
	yield takeEvery(SYNC_TEMPLATES, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp-namespaces-sync");
			toastNotification({ res });
			if (res && res.status == "success") {
				yield put({ type: GET_TEMPLATES });
			}
		} catch (err) { }
	});
}

function* getChannelWhatsappNumbers() {
	yield takeEvery(GET_CHANNEL_WHATSAPP_NUMBERS, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp-numbers");

			yield put(saveChannelWhatsappNumbers(res.data));
		} catch (err) {
			toastNotification({ errorMessage: "Internal server error" });
		}
	});
}

function* sendWhatsappMessengerSettingsSaga() {
	yield takeEvery(SEND_WHATSAPP_MESSENGER_SETTINGS, function* (action) {
		try {
			const { whatsappNumber, settings } = action.payload;

			yield ApiService.post(
				`/hulk/api/v1/whatsapp-settings/${whatsappNumber}`,
				{},
				{
					...settings,
				}
			);
			toastNotification({
				successMessage: "Whatsapp Settings updated successfully",
			});
		} catch (err) {
			toastNotification({
				errorMessage: "Internal server error",
			});
		}
	});
}

function* getWhatsappMessengerSettings() {
	yield takeEvery(GET_WHATSAPP_MESSENGER_SETTINGS, function* (action) {
		try {
			const { data } = yield ApiService.get(
				`/hulk/api/v1/whatsapp-settings/${action.payload}`
			);

			yield put(saveWhatsappMessengerSettings(data));
		} catch (err) {
			yield put(saveWhatsappMessengerSettings(null));
			toastNotification({
				errorMessage: "Internal server error",
			});
		}
	});
}

function* getWhatsappNumberConversationAnalyitcs() {
	yield takeEvery(GET_WHATSAPP_NUMBER_CONVERSATION_ANALYTICS, function* (action) {
		try {
			const res = yield ApiService.get("/hulk/api/v1/whatsapp_usage", {}, action.payload);
			yield put(saveWhatsappNumberConversationAnalyitcs(res.data));
		} catch (err) {
		}
	});
}

export default function* rootSaga() {
	yield all([
		getNameSpace(),
		updateNameSpace(),
		getTemplates(),
		createTemplate(),
		deleteTemplate(),
		getBrandStyles(),
		updateBrandStyles(),
		getWhatsappNumberAdminSaga(),
		postWhatsappNumberAdmin(),
		syncTemplates(),
		getChannelWhatsappNumbers(),
		sendWhatsappMessengerSettingsSaga(),
		getWhatsappMessengerSettings(),
		getWhatsappNumberMetricsSaga(),
		getWhatsappNumberConversationAnalyitcs()
	]);
}
